import React from 'react';

export default function GigaGod() {
  return (
    <main className="gigagod-frame-page">
      <iframe
        className="gigagod-frame"
        src="https://giglings.pages.dev/"
        title="Giga God Racing"
      />
    </main>
  );
}
